import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

const File = ({ name, ...rest }) => {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, registerField } = useField(name);
    //, error

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);
    return <input ref={inputRef} defaultValue={defaultValue} {...rest} type="file" />;
};

export default File;
